import type { ExposedMenu } from '@moniebook-web/components/widgets/sidebar/types';
import { HomeFill } from '@moniebook-web/icons/buildings/home-fill';
import { Home } from '@moniebook-web/icons/sidebar-rail/home';
import { ApplicationModule, MENU_SECTIONS, PAGES } from '@moniebook-web/types';

export const dashboardMenu: ExposedMenu = {
    menuGroups: [],
    submenu: [
        {
            sectionId: MENU_SECTIONS.NONE,
            order: 1,
            name: 'Home',
            to: PAGES.HOME,
            icon: <HomeFill />,
        },
    ],
    modules: [
        {
            id: ApplicationModule.HOME,
            name: 'Home',
            order: 1,
            icon: <Home />,
            backgroundColor: '#DBEAFE',
            foregroundColor: '#0357EE',
            to: PAGES.HOME,
        },
    ],
    subModules: [],
};
